export default __webpack_public_path__ + "static/media/Obi-Cover.60fff492.png";